// extracted by css-extract-rspack-plugin
export default {"headerRow":"SavedViews-module__headerRow__TMNUF","savedViewsList":"SavedViews-module__savedViewsList__jQW4m"};